import {IDelete} from "../interfaces/requests";
import {api} from "../../../helpers";

export const axiosDelete = ({url}: IDelete) => {
  return api.delete(url);
};
